import * as ProgressPrimitive from '@radix-ui/react-progress';
import classNames from 'classnames';
import type { PropsWithChildren } from 'react';

import Button from '~/components/Button';

import useSignupRedirects from '~/hooks/useUtils/useSignupRedirects';

const BAR_HEIGHT = 'h-[60px]';
const CHILDREN_MARGIN_TOP = 'mt-[60px]';

const SignupFlow = ({ children }: PropsWithChildren) => {
  const { nextPage, progress, steps } = useSignupRedirects();
  const hasMultipleRedirects = steps.length > 1;

  return (
    <>
      <div className={classNames('fixed right-0 top-0 z-10 flex w-full justify-end bg-white px-4 py-2', BAR_HEIGHT)}>
        <div className="flex items-center gap-2">
          <Button onClick={nextPage}>Next</Button>
        </div>
        {hasMultipleRedirects && (
          <div className="absolute bottom-0 left-0 z-20 w-full">
            <ProgressPrimitive.Root value={progress}>
              <ProgressPrimitive.Indicator
                className="h-[4px] w-full rounded-full bg-wt-primary transition-all"
                style={{ width: `${progress}%` }}
              />
            </ProgressPrimitive.Root>
          </div>
        )}
      </div>
      <div className={classNames(CHILDREN_MARGIN_TOP)}>{children}</div>
    </>
  );
};

export default SignupFlow;
